function toast() {
  const text = this.getAttribute("text");
  const icon = this.getAttribute("icon");

  const markup = `
    <div class="flex px-3 pt-2 pb-1">
      <p class="text-sm text-gray-700 dark:text-neutral-400">${text}</p>
      <div class="ms-auto">
        <button onclick="closeTostify(this)" type="button" class="inline-flex shrink-0 justify-center items-center size-5 rounded-lg text-gray-800 opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100 dark:text-white" aria-label="Close">
          <span class="sr-only">Close</span>
          <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
        </button>
      </div>
    </div>
  `;
  Toastify({
    text: markup,
    className:
      "hs-toastify-on:opacity-100 opacity-0 fixed -top-[150px] right-[20px] z-[90] transition-all duration-300 w-[320px] bg-amber-400 text-sm text-gray-700 border border-amber-200 rounded-md shadow-sm [&>.toast-close]:hidden",
    duration: 3000,
    close: true,
    escapeMarkup: false,
  }).showToast();
}

export { toast };
